// extracted by mini-css-extract-plugin
export default {"separator":"Separator_separator__WoiMM","lightSeparator":"Separator_lightSeparator__mQ6Ex","darkSeparator":"Separator_darkSeparator__Wjs2d"};